<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 39 32"
  >
    <g
      :fill="color"
      class="fill-current"
    >
      <path d="M39.385 3.774c-1.337 0.647-2.89 1.11-4.525 1.306l-0.070 0.007c1.652-1.034 2.913-2.559 3.59-4.37l0.020-0.060c-1.46 0.917-3.167 1.602-4.993 1.954l-0.094 0.015c-1.539-1.595-3.686-2.594-6.066-2.626l-0.006-0c-4.459 0.008-8.071 3.625-8.071 8.085 0 0.624 0.071 1.232 0.205 1.815l-0.011-0.054c-6.706-0.285-12.615-3.47-16.54-8.326l-0.033-0.042c-0.697 1.173-1.109 2.587-1.109 4.097 0 2.789 1.406 5.249 3.548 6.711l0.028 0.018c-1.336-0.142-2.559-0.488-3.684-1.010l0.072 0.030c-0.001 0.042-0.001 0.092-0.001 0.141 0 3.867 2.718 7.099 6.348 7.89l0.053 0.010c-0.661 0.175-1.421 0.276-2.204 0.276-0.496 0-0.983-0.040-1.458-0.118l0.052 0.007c0.981 3.252 3.95 5.579 7.462 5.579 0.030 0 0.060-0 0.091-0.001l-0.005 0c-2.753 2.118-6.249 3.395-10.044 3.395-0.683 0-1.357-0.041-2.018-0.122l0.080 0.008c3.482 2.254 7.737 3.599 12.305 3.61h0.003c0.037 0 0.082 0 0.126 0 12.633 0 22.875-10.241 22.875-22.875 0-0.381-0.009-0.76-0.028-1.136l0.002 0.053c1.614-1.183 2.975-2.596 4.065-4.208l0.038-0.060z" />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: 'currentColor'
    }
  }
}
</script>
